import { render, staticRenderFns } from "./UserStatus.vue?vue&type=template&id=43220afa&scoped=true&lang=pug&"
import script from "./UserStatus.vue?vue&type=script&lang=js&"
export * from "./UserStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserStatus.vue?vue&type=style&index=0&id=43220afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43220afa",
  null
  
)

export default component.exports